import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import BodyModule from "@/store/modules/BodyModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";
import CursosModule from "@/store/modules/CursosModule";
import EncuestaModule from "@/store/modules/EncuestaModule";
import FamiliasModule from "@/store/modules/FamiliasModule";
import FormulariosModule from "@/store/modules/FormulariosModule";
import HomeModule from "@/store/modules/HomeModule";
import InscripcionModule from "@/store/modules/InscripcionModule";
import ServiciosProgramadosModule from "@/store/modules/ServiciosProgramadosModule";
import { AuthModule } from "@/store/modules/auth/AuthModule";

config.rawError = true;

const store = createStore({
  modules: {
    AuthModule,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
    CursosModule,
    FamiliasModule,
    FormulariosModule,
    HomeModule,
    InscripcionModule,
    ServiciosProgramadosModule,
    EncuestaModule,
  },
});

export default store;
